export const invite = {
  fuwutiaokuan: 'Conditions d utilisation',
  yinsizhengce: 'Politique de confidentialité',
  fzcg: 'Copie réussie',
  yqhy: "Inviter des amis",
  fxlj: "Partager le lien",
  register_now: 'S inscrire maintenant',
  phone: 'Téléphone',
  email: 'Email',
  placehold_phone: 'Veuillez entrer votre numéro de téléphone',
  placehold_email: 'Veuillez entrer votre email',
  placehold_code: 'Code d invitation',
  argee: 'J ai lu et j accepte',
  agreement: 'Contrat utilisateur Biking',
  register: 'S inscrire',
  phone_code: 'Code de vérification SMS',
  email_code: 'Code de vérification email',
  code_to_phone: 'Le code de vérification a été envoyé par SMS à votre téléphone',
  code_to_email: 'Le code de vérification a été envoyé à votre email',
  has_sent: 'Code envoyé à :',
  resend: 'Renvoyer',
  send_code: 'Envoyer le code',
  unable_code: 'Pas reçu le code ?',
  set_pwd: 'Définir le mot de passe',
  placehold_pwd: 'Veuillez entrer votre mot de passe',
  submit: 'Soumettre',
  error_phone: 'Veuillez entrer un numéro de téléphone valide',
  error_email: 'Format email invalide, Veuillez réessayer',
  error_checked: 'Veuillez cocher la case d accord',
  text: 'Format de mot de passe invalide. Le mot de passe doit contenir 8-32 caractères, avec majuscules, minuscules et chiffres.',
  validate: 'Veuillez compléter la vérification',
  register_success: 'Inscription réussie !',
  welcome: 'Bienvenue sur Biking',
  start_trade: 'Déposez des cryptomonnaies pour commencer à trader',
  safe: 'Plusieurs méthodes de dépôt, trading sécurisé et pratique',
  pay_type: 'Acheter/vendre des cryptomonnaies par银行卡 ou autres méthodes',
  right_now_download: 'Télécharger maintenant',
  right_download: 'Télécharger',
  'Please_enter_correct_phone_number':'Veuillez entrer un numéro de téléphone valide',
  'Referral_code':'Veuillez entrer votre code d invitation',
  'I_have_read_and_agree':'J ai lu et j accepte',
  'BiKing_User_Agreement':'Contrat utilisateur Biking',
  'Please_enter_password':'Veuillez entrer votre mot de passe',
  'Email_verification_code':'Code de vérification email',
  'SMS_code':'Code de vérification SMS',
  'Incorrect_email_format_please_reenter':'Format email invalide, Veuillez réessayer',
  'Please_read_and_agree_User_Agreement':'Veuillez lire et accepter le contrat utilisateur',
  'Sent_code_to':'Code envoyé à',
  zjff: 'Distribution directe !',
  ycxdz: 'Arrivée en une fois !',
  bbsy: 'Zéro coût pour des rendements centuplés !',
  sdly: 'Trois raisons de choisir Biking',
  aqfktx: 'Système de sécurité de niveau mondial',
  aqhg: 'Sécurisé et conforme, réseau de valeur fiable, architecture distribuée professionnelle et protection anti-DDoS',
  qqbthyytd: 'Équipes de opération本地isées dans le monde',
  qqbj: 'Présence mondiale, services locaux dans plusieurs pays',
  fwtx: 'Système centré sur l utilisateur',
  yhzs: 'L utilisateur est_priorité, mécanisme de remboursement先行, fonds de protection utilisateur',
  jslc: 'Processus de déblocage',
  zcwcjkjs: 'Après l inscription, les 1188 USDT sont crédités sur le compte de bonus.',
  czts: 'Exemple : Vous utilisez les 1000 USDT reçus pour acheter un ordre long BTC à 20x levier. Quand BTC augmente de 1%, vous gagnez 200 USDT, directement retirables.',
  zhu: 'Note :',
  qzlqyky: '1188 USDT distribués en une fois, utilisables sur tous les contrats',
  gqql: 'Les 1188 USDT sont valides 1 mois, expirent ensuite',

}


// WEBPACK FOOTER //
// ./src/i18n/lang/invite/fr.js